import { PackageTemplate, DimensionUnit } from '@freight-cbm/shared-types';

export const PACKAGE_TEMPLATES: PackageTemplate[] = [
  { name: 'Euro Pallet', length: 120, width: 80, height: 144, dimUnit: DimensionUnit.Cm },
  { name: 'Standard Carton (S)', length: 40, width: 30, height: 30, dimUnit: DimensionUnit.Cm },
  { name: 'Standard Carton (M)', length: 50, width: 40, height: 40, dimUnit: DimensionUnit.Cm },
  { name: 'Standard Carton (L)', length: 60, width: 50, height: 50, dimUnit: DimensionUnit.Cm },
  { name: 'US Pallet (48×40)', length: 48, width: 40, height: 48, dimUnit: DimensionUnit.In },
  { name: 'Bulk Bag (1 CBM)', length: 100, width: 100, height: 100, dimUnit: DimensionUnit.Cm },
];
